import API from '../api'

export default function apiStore(client, middlewares) {

  return function apiStoreDecorator(target) {

    const provider = target.prototype || target

    provider.initAPIStore = function initAPIStore(opts) {
      this.api = new API(this, client, opts, middlewares)
    }

    /**
     * Determines whether or not the resources of this store were ever loaded completely
     */
    provider.didCompleteLoad = function didCompleteLoad() {
      return this.api.didCompleteLoad
    }

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/decorators/store.js